import { render, staticRenderFns } from "./VenueAddress.vue?vue&type=template&id=020aceda&scoped=true&"
import script from "./VenueAddress.vue?vue&type=script&lang=js&"
export * from "./VenueAddress.vue?vue&type=script&lang=js&"
import style0 from "./VenueAddress.vue?vue&type=style&index=0&id=020aceda&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020aceda",
  null
  
)

export default component.exports